
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import DashboardContainer from '../../Dashboard/DashboardContainer';
import EntityContainer from '../../Entity/EntityContainer';
import LoginContainer from '../../Login/LoginContainer';
import NotFoundView from './NotFoundVIew';
import RatePlanContainer from '../../RatePlans/RatePlanContainer';
import TransactionContainer from '../../Transaction/TransactionContainer';
import MembersContainer from '../../Members/MembersContainer';
import EntityReportContainer from '../../EntityReport/EntityReportContainer';
import LoginImageContainer from '../../LoginImage/LoginImageContainer';

const AppView: React.FC =
  () =>
    (
      <Routes>
        <Route path='/' element={<LoginContainer />} />
        <Route path='/login/callback' element={<LoginCallback />} />
        <Route path='/branches/:branchId' element={<DashboardContainer />} />
        <Route path='/dashboard' element={<DashboardContainer />} />
        <Route path='/entity/:entityId/' element={<EntityContainer />} />
        <Route path='/rate-plans/' element={<RatePlanContainer />} />
        <Route path='/add-transaction/' element={<TransactionContainer />} />
        <Route path='/transaction/:transactionId' element={<TransactionContainer />} />
        <Route path='/members' element={<MembersContainer />} />
        <Route path='/balance-report' element={<EntityReportContainer />} />
        <Route path='/login-image' element={<LoginImageContainer />} />
        <Route path='*' element={<NotFoundView />} />
      </Routes>
    )

export default AppView
